import { Copy } from 'lucide-react';
import { Button } from '@reflex/ui/components/ui/button';
import { SectionLabel } from '@reflex/ui/components/layout/Typography';
import { toast } from 'sonner';

interface CopyRowProps {
  label: string;
  value: string;
}

/**
 * Compact label + monospaced value + icon-only copy button. Used inside the
 * wizard's plugin step rows for redirect URIs and webhook URLs. Stacked
 * vertically so the URL has the full row width to itself instead of being
 * squashed beside a fixed-width label column.
 */
export function CopyRow({ label, value }: CopyRowProps) {
  return (
    <div data-testid="copy-row" className="space-y-1">
      <SectionLabel as="h4">{label}</SectionLabel>
      <div className="flex items-stretch gap-2">
        <code className="min-w-0 flex-1 overflow-x-auto rounded-md border border-border/40 bg-muted/30 px-3 py-2 font-mono text-xs leading-tight">
          {value}
        </code>
        <Button
          type="button"
          size="icon-sm"
          variant="outline"
          aria-label={`Copy ${label}`}
          onClick={() => {
            void navigator.clipboard.writeText(value);
            toast.success('Copied');
          }}
        >
          <Copy className="icon-xs" />
        </Button>
      </div>
    </div>
  );
}
